module.exports = __webpack_public_path__ + "img/basic_skinwash_set_202308.533d2825.jpg";